import type { Phrases } from '../../types';

const textWithoutWhitespacesAroundRegex = /[^\s](.|[\r\n\u2028])*[^\s]/;

export function textSetter(nodes: Node[], phrases: Phrases) {
  for (let i = 0; i < nodes.length; i++) {
    nodes[i].nodeValue =
      nodes[i].nodeValue?.replace(
        textWithoutWhitespacesAroundRegex,
        () => phrases[i]
      ) ?? phrases[i];
  }
}
